<template>
  <v-overlay :value="dialog" opacity="0.2">
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>
<script>
export default {
  data: () => {
    return {
      show: false,
      min: 300 // lowest load time.
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // dialog(){
    //   if(dialog == )
    // }
  }
};
</script>
